import PropTypes from 'prop-types';
import React from 'react';
import './_Title.scss';

function Title(props) {
    const mod_class = [
        'Title',
        props.align !== undefined ? 'align-' + props.align : '',
        props.size !== undefined ? 'size-' + props.size : '',
        props.theme !== undefined ? 'theme-' + props.theme : '',
        props.font !== undefined ? 'font-' + props.font : '',
        props.noMargin !== undefined ? 'no-margin' : '',
        props.invisible !== undefined ? 'is-invisible' : '',
        props.strikethrough === true ? 'is-strikethrough' : '',
        props.className ? props.className : '',
    ]
        .join(' ')
        .replace(/\s{2,}/g, ' ');

    function renderEl() {
        if (props.tag === 'h1') {
            return <h1 className={mod_class}>{props.children}</h1>;
        } else if (props.tag === 'h2') {
            return <h2 className={mod_class}>{props.children}</h2>;
        } else if (props.tag === 'h3') {
            return <h3 className={mod_class}>{props.children}</h3>;
        } else if (props.tag === 'h4') {
            return <h4 className={mod_class}>{props.children}</h4>;
        } else if (props.tag === 'span') {
            return <span className={mod_class}>{props.children}</span>;
        } else {
            return <p className={mod_class}>{props.children}</p>;
        }
    }

    return renderEl();
}

Title.propTypes = {
    tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'p', 'span']),
    theme: PropTypes.oneOf(['dark', 'light', 'white', 'soft', 'white-lighter']),
    align: PropTypes.oneOf(['left', 'center', 'right']),
    size: PropTypes.oneOf([
        'xxs',
        'xs',
        's',
        'm',
        'ml',
        'l',
        'ul',
        'xl',
        'xxl',
        'giant',
    ]),
    font: PropTypes.oneOf(['primary', 'alt']),
    children: PropTypes.node,
    className: PropTypes.string,
    noMargin: PropTypes.bool,
};

Title.defaultProps = {
    tag: 'p',
    theme: 'dark',
    align: 'left',
    size: 'xl',
    font: 'primary',
    noMargin: undefined,
};

export default Title;
